import { Injectable, Inject } from '@angular/core';
import { map, first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { CommonService } from '@services/app.common.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StatusCode } from '../_enums/Common';
import { IdServer } from '../_enums/idServer';
import { RoleAccessService } from './role.access.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
  public _baseUrl;
  private redirectUrl: string = 'Home';
  private isloggedIn: boolean = false;
  private loginUrl: string = '/Login';
  public error = '';
  private appUrl: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, private common: CommonService, public roleService: RoleAccessService, private router: Router) {
    this._baseUrl = baseUrl + "api/";
    if (environment.production)
      this.appUrl = this._baseUrl;
    else
      this.appUrl = this.serviceUrl;
  }
  private serviceUrl = environment.LoginUrl;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS', 'Access-Control-Allow-Headers': '*' });
  private options = { headers: this.headers };
  login(username: string, password: string, callback?: any) {
    var $this = this;
    this.http.post(this.appUrl + this.common.ApiUrls.Login.Login, { UserName: username, Password: password }).pipe(first()).subscribe(data => {
        var res: any;
        res = data;
        if (res.status == StatusCode.OK) {
          let loginConfig = this.common.JsonParseData(res.resultData.loginConfiguration)

          if (loginConfig.FeatureTwoFa) {
            if (loginConfig.ForceTwoFactorAuthentication) {
              this.navigate(loginConfig.IsTwoFactorEnabled ? "/2FA/VerifyCode" : "/2FA/TwoFactorAuthentication", loginConfig);
            }
            else {
              if (loginConfig.IsTwoFactorEnabled && !loginConfig.IsTwoFactorDisabledByUser) {
                this.navigate("/2FA/VerifyCode", loginConfig);
              }
              else
                this.doLogin(callback, loginConfig, res.resultData.access_token);
            }
          }
          else {
            this.doLogin(callback, loginConfig, res.resultData.access_token);

          }
        }
        else {
          //$this.common.Loader.hide();
          $this.error = 'Invalid Username or Password';

          this.common.loginButtonText = 'Log in';
        }
      });
  }

  GetOwnSecurityRole(callback?: any) {
    var $this = this;
    this.common.GetData(this.common.ApiUrls.Login.GetOwnSecurityRoleDetail, true).then(function (data) {
      if (data.status == StatusCode.OK) {
         
        $this.common.SetLocalStorage('active_menu_index', '1');
        $this.common.RemoveLocalStorage("jt_permissions");
        $this.common.RemoveLocalStorage("jt_user_info");
        $this.common.RemoveLocalStorage("whiteLabel_permissions");
        $this.common.SetLocalStorage('jt_date_format', data.resultData.dateFormat);
        let url = $this.getRedirectUrl();
        console.log(url);
        $this.common.SetLocalStorage('jt_permissions', JSON.stringify(data.resultData.securityRoleDetail));
        $this.common.SetLocalStorage('jt_user_info', JSON.stringify(data.resultData.user));
        $this.common.SetLocalStorage('whiteLabel_permissions', JSON.stringify(data.resultData.whitelabelsecuritysettings));

        let accessType = "Access";
        if (url.toString() == "Home" && !$this.roleService.HasAccess("Dashboard", accessType))
          url = url;

        $this.common.loginButtonText = 'Log in';
        //$this.common.Loader.hide();
        $this.router.navigateByUrl(url);
        if (callback)
          callback();
      }
      else {
        $this.error = 'Invalid Username or Password';
        $this.common.loginButtonText = 'Log in';
        //$this.common.Loader.hide();
      }
    });
  }

  refreshToken() {

    return this.http
      .post(this.appUrl + this.common.ApiUrls.Login.RefreshToken, {});


  }

  public GetTokenByType(type: number) {

    var url = "";
    if (type == IdServer.TokenType.Anonymous)
      url = this.common.ApiUrls.Login.AnonymousToken;
    else if (type == IdServer.TokenType.Sso)
      url = this.common.ApiUrls.Login.SSOToken;
    else if (type == IdServer.TokenType.SSOLogin)
      url = this.common.ApiUrls.Login.SSOLogin;
    url = this.appUrl + url;
    return this.http
      .post(url, {}).pipe(map((data: any) => {
        var result = data;
        if (result.status == StatusCode.OK) {
          return result;
        } else {
          return null;
        }
      }));
  }

  isUserLoggedIn(): boolean {

    const helper = new JwtHelperService();
    var token = this.common.GetAccessToken();
    return !helper.isTokenExpired(token);
  }
  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }
  getLoginUrl(): string {
    return this.loginUrl;
  }

  logout() {
    // remove user from local storage to log user out
    this.common.ClearLocalStorageOnlogOut();
  }

  GetTokenExpirationDate(): Date {
    var token = this.common.GetAccessToken();
    const helper = new JwtHelperService();
    return helper.getTokenExpirationDate(token) ?? new Date();
  }

  doLogin(callback: any, loginConfig: any, accessToken: string): void {
    this.common.SetAccessToken(accessToken);
    this.common.RemoveLocalStorage("TotalNotifications");
    this.common.SetLocalStorage('2FAConfiguration', JSON.stringify(loginConfig));
    this.GetOwnSecurityRole(callback);
  }
  navigate(route: string, loginConfig: any): void { debugger
    this.common.SetLocalStorage('2FAConfiguration', JSON.stringify(loginConfig));
    this.common.NavigateToRouteWithQueryString(route);
  }
}
